import React from 'react'
import {
   Icon,
   Menu,
   Button
} from 'semantic-ui-react'
import { useHistory, NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { logoutAction } from '../Redux/Actions/AuthAction'
import { getSettings } from '../Redux/Actions/SettingsAction'
import { toggleMenu } from "../Redux/Actions/ButtonAction";
import { ToastContainer, Slide, toast } from 'react-toastify';

const AppHeader = (props) => {

   let history = useHistory();
   const dispatch = useDispatch()
   const authToken = localStorage.getItem('accessToken');
   const [toggle, setToggle] = React.useState(true);

   const handleToggleMenu = () => {
      dispatch(getSettings(authToken, toast))
      setToggle(toggle => !toggle)
      dispatch(toggleMenu(toggle))
   }

   return (
      <React.Fragment>
         <Menu secondary className="app-header">
            <Menu.Item
               onClick={handleToggleMenu}
               name='home'>
               <Icon name={props.isActiveSidebar ? 'indent' : 'outdent'} color='grey' size='large' />
            </Menu.Item>
            <Menu.Item
               name='home'
               as={NavLink}
               to="/"
            />
            <Menu.Item
               name='employee'
               as={NavLink}
               to="/employee"
            />
            <Menu.Item
               name='attendance'
               as={NavLink}
               to="/attendance"
            />
            <Menu.Menu position='right'>
               {/* <Menu.Item as={NavLink} to="/settings">
                  <Icon name='cog' size="large" style={{margin: 0}} />
               </Menu.Item> */}
               <Menu.Item onClick={() => dispatch(logoutAction(authToken, history))}>
                  Logout
               </Menu.Item>
               <Menu.Item>
                  <Icon name='braille' color='grey' size='large' />
               </Menu.Item>
            </Menu.Menu>
         </Menu>
         <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            transition={Slide}
         />
      </React.Fragment>
   )
}

export default AppHeader